import {
	VIDEO_DURATION_OUT_OF_RANGE,
	VIDEO_DURATION_UNREADABLE,
	VIDEO_MAX_SECONDS,
	VIDEO_MIN_SECONDS,
} from '@libs/dtos/merit/onboarding.dto';

type Translate = (key: string, params?: Record<string, unknown>) => string;

/**
 * The candidate-facing sentence for the 30–90 s video rule, or `null` when the
 * error is something else (21/09).
 *
 * The server answers every door that takes a presentation video with the same
 * two codes (`assertPresentationVideoDuration`). The screens used to paint
 * `error.message` as it came, so without this the candidate would read a code;
 * written once, so the wizard, the public signup and the company-requested
 * video say the same thing.
 */
export function videoDurationErrorMessage(err: unknown, t: Translate): string | null {
	const message = (err as { error?: { message?: unknown } })?.error?.message;
	if (typeof message !== 'string') return null;
	if (message === VIDEO_DURATION_UNREADABLE) {
		return t('errors.videoDurationUnreadable');
	}
	if (message.startsWith(`${VIDEO_DURATION_OUT_OF_RANGE}:`)) {
		const seconds = message.slice(VIDEO_DURATION_OUT_OF_RANGE.length + 1);
		return t('errors.videoDurationOutOfRange', { seconds, min: VIDEO_MIN_SECONDS, max: VIDEO_MAX_SECONDS });
	}
	return null;
}
